import React, { useEffect, useState, useRef } from "react"
import styled from "styled-components"
import Layout from "../components/layout"
import { withPrefix } from "gatsby"
import SEO from "../components/seo"
import ContactBar from "../components/contact-bar"
import ModeTabs from "../components/mode-tabs"

// Styled Components
const PageContainer = styled.div`
  font-family: "Rubik", sans-serif;
  color: #333;
  direction: rtl;
  background: #bdf1ff;
`

const HeroSection = styled.div`
  position: relative;
  height: 60vh;
  min-height: 400px;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
`

const HeroTopBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: grid;
  grid-template-columns: 220px 1fr auto;
  align-items: start;
  gap: 16px;
  padding: 14px 18px;

  @media (max-width: 900px) {
    grid-template-columns: 120px 1fr;
    grid-template-rows: auto auto;
    align-items: center;
  }
`

const BrandColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`

const LogoWrap = styled.div`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
`

const LogoImg = styled.img`
  width: 220px;
  height: auto;
  display: block;

  @media (max-width: 900px) {
    width: 170px;
  }
`

// (Upper phone removed - phone remains near the contact icons row)

const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  object-fit: cover;
  object-position: center 65%;
`

const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
`

const HeroContent = styled.div`
  position: relative;
  z-index: 3;
  text-align: center;
  color: yellow;
  padding: 20px;
`

const HeroTitle = styled.h1`
  font-size: 5.5rem;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  color: #ffc74c;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`

const HeroSubtitle = styled.p`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
  color: #ffc74c;
  line-height: 1.2;
  margin-left: auto;
  margin-right: auto;
  max-width: 900px;

  @media (max-width: 480px) {
    font-size: 1.15rem;
    line-height: 1.15;
    margin-bottom: 1.25rem;
    padding: 0 10px;
  }
`

const FilterContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 12px 16px 26px;
  background-color: #bdf1ff;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`

const FilterButton = styled.button`
  background: ${props => props.active ? '#333' : 'transparent'};
  color: ${props => props.active ? '#fff' : '#333'};
  border: 1px solid #333;
  padding: 10px 26px;
  margin: 6px 8px;
  border-radius: 30px;
  cursor: pointer;
  font-size: 1.05rem;
  transition: all 0.3s ease;
  font-family: inherit;

  &:hover {
    background: #333;
    color: #fff;
  }

  @media (max-width: 600px) {
    padding: 8px 14px;
    font-size: 0.9rem;
    margin: 5px;
  }
`

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  padding: 40px 5vw;
  background-color: #bdf1ff;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  transition: transform 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
  }
`

const CardMedia = styled.div`
  position: relative;
`

const CardImage = styled.div`
  height: 250px;
  background-color: #eee;
  background-image: url("${props => props.src}");
  background-size: cover;
  background-position: center;
`

const PlayOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

const PlayButton = styled.div`
  width: 74px;
  height: 74px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 14px 30px rgba(0,0,0,0.25);

  &::before {
    content: "";
    display: block;
    margin-left: 4px;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    border-left: 18px solid rgba(255,255,255,0.92);
  }
`

const CardContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  text-align: center;
`

const CardTitle = styled.h3`
  margin: 0 0 10px 0;
  font-size: 1.4rem;
  color: #222;
`

const CardCategory = styled.span`
  font-size: 0.9rem;
  color: #888;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
`

const CardId = styled.span`
  font-size: 0.8rem;
  color: #aaa;
  margin-top: 5px;
  background: #f0f0f0;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
  align-self: center;
`

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.72);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
`

const ModalContent = styled.div`
  position: relative;
  width: min(1100px, 96vw);
  max-height: 92vh;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 18px;
  padding: 14px;
  backdrop-filter: blur(10px);
`

const ModalCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 20;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.25);
  background: rgba(0,0,0,0.35);
  color: white;
  font-size: 20px;
  cursor: pointer;
  transition: transform 160ms ease, background 160ms ease;

  &:hover {
    transform: translateY(-1px);
    background: rgba(0,0,0,0.5);
  }
`

const ModalImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 82vh;
  object-fit: contain;
  border-radius: 14px;
  display: block;
`

const CardVideoThumb = styled.video`
  width: 100%;
  height: 250px;
  object-fit: cover;
  display: block;
  background: #000;
`

const ModalVideo = styled.video`
  width: 100%;
  height: auto;
  max-height: 82vh;
  border-radius: 14px;
  background: black;
  display: block;
`

const ModalCaption = styled.div`
  margin-top: 10px;
  color: rgba(255,255,255,0.92);
  text-align: center;
  font-weight: 700;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.35);
`

// Data constructed from folder structure
const MENU_ITEMS = [
  // Meat Items
  { id: "meat-1", title: "סנדוויץ' חלה עם שניצל", category: "meat", image: "/images/meat/20210930_194746.jpg" },
  { id: "meat-2", title: "קדירות בשר", category: "meat", image: "/images/meat/20230316_145304.jpg" },
  { id: "meat-3", title: "רוסטביף מגולגל עם צ'ימיצ'ורי", category: "meat", image: "/images/meat/20240202_150255.jpg" },
  { id: "meat-4", title: "פילה/סינטה", category: "meat", image: "/images/meat/20240913_091520.jpg" },
  { id: "meat-5", title: "סוכריות עראייס", category: "meat", image: "/images/meat/20250909_192415.jpg" },
  { id: "meat-6", title: "רצועות רוסטביף", category: "meat", image: "/images/meat/IMG_20220412_080711_513.jpg" },
  { id: "meat-7", title: "רוסטביף על הרשת", category: "meat", image: "/images/meat/IMG_20220818_121210_558.jpg" },
  { id: "meat-8", title: "פוקצ'ה עראייס", category: "meat", image: "/images/meat/IMG_20230531_162853.jpg" },
  { id: "meat-9", title: "מבחר בשרים על האש", category: "meat", image: "/images/meat/IMG-20220806-WA0024.jpg" },
  { id: "meat-10", title: "ה-המבורגר", category: "meat", image: "/images/meat/IMG-20230305-WA0040.jpg" },
  { id: "meat-11", title: "מיני המבורגר - קומפלט", category: "meat", image: "/images/meat/IMG-20230630-WA0040.jpg" },
  { id: "meat-12", title: "עוף בסגנון רוטיסרי", category: "meat", image: "/images/meat/20250905_175809.jpg" },
  { id: "meat-13", title: "רביולי עם בשר מפורק", category: "meat", image: "/images/meat/5803fbcbacdc9bcea8a750d312a31d2a_1768122669877_0.webp.jpg" },
  { id: "meat-14", title: "טאקו קבב (עבודת יד)", category: "meat", image: "/images/meat/taco-kebab-handmade.jpg" },

  // Vegetarian Items
  { id: "veg-1", title: "סלט אנטיפסטי", category: "vegetarian", image: "/images/vegetarian/20211108_141744.jpg" },
  { id: "veg-2", title: "פלטת ירקות", category: "vegetarian", image: "/images/vegetarian/20240628_131037.jpg" },
  { id: "veg-3", title: "סלט בוראטה", category: "vegetarian", image: "/images/vegetarian/20240727_180616.jpg" },
  { id: "veg-4", title: "פיצות", category: "vegetarian", image: "/images/vegetarian/20250210_125914.jpg" },
  { id: "veg-5", title: "סלט קפרזה", category: "vegetarian", image: "/images/vegetarian/20251024_135528.jpg" },
  { id: "veg-6", title: "פוקצ'ה אנטיפסטי", category: "vegetarian", image: "/images/vegetarian/20251114_125453.jpg" },
  { id: "veg-7", title: "פיצות נפוליטנה", category: "vegetarian", image: "/images/vegetarian/20251212_154419.jpg" },
  { id: "veg-8", title: "כדורי פלאפל", category: "vegetarian", image: "/images/vegetarian/IMG_20220401_092927_406.jpg" },
  { id: "veg-9", title: "חמשוקה", category: "vegetarian", image: "/images/vegetarian/IMG_20220704_095651_208.jpg" },
  { id: "veg-10", title: "לזניה", category: "vegetarian", image: "/images/vegetarian/IMG_20230119_152618_759.jpg" },
  { id: "veg-11", title: "לביבות בטטה", category: "vegetarian", image: "/images/vegetarian/IMG-20230602-WA0045.jpg" },
  { id: "veg-12", title: "מבחר טאפאסים", category: "vegetarian", image: "/images/vegetarian/IMG-20231109-WA0042.jpg" },
  { id: "veg-13", title: "פלאפל חצילים", category: "vegetarian", image: "/images/vegetarian/IMG-20240611-WA0039.jpg" },
  { id: "veg-14", title: "אנטיפסטי", category: "vegetarian", image: "/images/vegetarian/IMG-20240624-WA0048.jpg" },
  { id: "veg-15", title: "פלאפל מהסרטים", category: "vegetarian", image: "/images/vegetarian/IMG_20240104_150452_602.jpg" },
  { id: "veg-16", title: "ענני ניוקי עבודת יד", category: "vegetarian", image: "/images/vegetarian/IMG_20230817_122457_925.jpg" },
  { id: "veg-17", title: "פיצה נוטלה", category: "vegetarian", image: "/images/vegetarian/IMG-20250613-WA0034.jpg" },

  // Salads
  { id: "salad-1", title: "סלט קינואה", category: "salads", image: "/images/salads/20231002_105253.jpg" },
  { id: "salad-2", title: "פרחי ירקות", category: "salads", image: "/images/salads/20240628_130947.jpg" },
  { id: "salad-3", title: "סלט עגבניות שרי", category: "salads", image: "/images/salads/IMG-20240624-WA0045.jpg" },
  { id: "salad-4", title: "קרפצ'יו סלק", category: "salads", image: "/images/salads/IMG-20240624-WA0050.jpg" },
  { id: "salad-5", title: "כרובית בטאבון", category: "salads", image: "/images/vibe/20240131_110342.jpg" },

  // Vibe
  { id: "vibe-2", title: "החצר", category: "vibe", image: "/images/vibe/facebook_1768560568111_7417880665071946351.jpg" },
  { id: "vibe-3", title: "תמיד עם חיוך", category: "vibe", image: "/images/vibe/facebook_1768560622344_7417880892543167053.jpg" },
  { id: "vibe-4", title: "בת מצווש", category: "vibe", image: "/images/vibe/facebook_1768560723205_7417881315584536608.jpg" },
  { id: "vibe-5", title: "בחצר", category: "vibe", image: "/images/vibe/facebook_1768560797926_7417881628985552747.jpg" },
  { id: "vibe-6", title: "הסיירת", category: "vibe", image: "/images/vibe/facebook_1768560934105_7417882200163046030.jpg" },
  { id: "vibe-7", title: "חצילים רוקדים סלסה ", category: "vibe", image: "/images/vibe/IMG-20211106-WA0008.jpg" },
  { id: "vibe-8", title: "מבחר סלטים", category: "vibe", image: "/images/vibe/IMG-20220701-WA0042.jpg" },
  { id: "vibe-9", title: "מהמטבח באהבה", category: "vibe", image: "/images/vibe/IMG-20260103-WA0027.jpg" },

  // Videos (placeholder titles for easy renaming)
  { id: "video-1", title: "פילה לברק בטאבון", category: "videos", image: "/images/logo.jpeg", video: "https://pub-ab43bc4b19a740dc9966f664f206b079.r2.dev/5.mp4" },
  { id: "video-2", title: "כשההמבורגר פוגש את האש", category: "videos", image: "/images/logo.jpeg", video: "https://pub-ab43bc4b19a740dc9966f664f206b079.r2.dev/8a.mp4" },
  { id: "video-3", title: "חגיגת גריל", category: "videos", image: "/images/logo.jpeg", video: "https://pub-ab43bc4b19a740dc9966f664f206b079.r2.dev/7.mp4" },
  { id: "video-4", title: "שווארמה על הפלנצ'ה", category: "videos", image: "/images/logo.jpeg", video: "https://pub-ab43bc4b19a740dc9966f664f206b079.r2.dev/6a.mp4" },
  { id: "video-5", title: "מסיבת חוף", category: "videos", image: "/images/logo.jpeg", video: "https://pub-ab43bc4b19a740dc9966f664f206b079.r2.dev/9.mp4" },
  { id: "video-6", title: "אוכל הצגה", category: "videos", image: "/images/logo.jpeg", video: "https://pub-ab43bc4b19a740dc9966f664f206b079.r2.dev/10a.mp4" }
];

const CATEGORIES = {
  meat: "בשרי",
  vegetarian: "צמחוני",
  salads: "סלטים",
  vibe: "אווירה",
  videos: "סרטונים",
};

export default function MainPage() {
  const [filter, setFilter] = useState('all');
  const videoRef = useRef(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const filteredItems = filter === 'all' 
    ? MENU_ITEMS 
    : MENU_ITEMS.filter(item => item.category === filter);

  useEffect(() => {
    if (!selectedItem) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (e.key === "Escape") setSelectedItem(null);
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [selectedItem]);

  return (
    <Layout>
      <SEO
        title="מהמטבח של סטיב"
        description="מהמטבח של סטיב פרנקל - אירועי בוטיק, מגשי אירוח ואוכל עד הבית"
        pathname="/"
        image="/images/logo.jpeg"
      />
      <PageContainer>
        <HeroSection>
          <HeroTopBar>
            <BrandColumn>
              <LogoWrap aria-label="Logo">
                <LogoImg src={withPrefix("/images/logo.svg")} alt="Logo" />
              </LogoWrap>
            </BrandColumn>
          </HeroTopBar>

          <VideoBackground 
            autoPlay 
            loop 
            muted 
            playsInline
            ref={videoRef}
            onLoadedMetadata={() => {
              if (videoRef.current) {
                videoRef.current.playbackRate = 0.5;
              }
            }}
          >
            <source src="https://pub-ab43bc4b19a740dc9966f664f206b079.r2.dev/VID-20260103-WA0025.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </VideoBackground>
          <HeroOverlay />
          <HeroContent>
            <HeroTitle>מהמטבח של סטיב</HeroTitle>
            <HeroSubtitle>חוויה קולינרית ייחודית</HeroSubtitle>
          </HeroContent>
        </HeroSection>

        <ModeTabs active="catering" />
        <ContactBar />

        <FilterContainer>
          <FilterButton active={filter === 'all'} onClick={() => setFilter('all')}>
            הכל
          </FilterButton>
          <FilterButton active={filter === 'meat'} onClick={() => setFilter('meat')}>
            בשרי
          </FilterButton>
          <FilterButton active={filter === 'vegetarian'} onClick={() => setFilter('vegetarian')}>
            צמחוני
          </FilterButton>
          <FilterButton active={filter === 'salads'} onClick={() => setFilter('salads')}>
            סלטים
          </FilterButton>
          <FilterButton active={filter === 'vibe'} onClick={() => setFilter('vibe')}>
            אווירה
          </FilterButton>
          <FilterButton active={filter === 'videos'} onClick={() => setFilter('videos')}>
            סרטונים
          </FilterButton>
        </FilterContainer>

        <GalleryGrid>
          {filteredItems.map(item => (
            <Card
              key={item.id}
              role="button"
              tabIndex={0}
              onClick={() => setSelectedItem(item)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") setSelectedItem(item);
              }}
              aria-label={`Open ${item.id}`}
            >
              <CardMedia>
                {item.video ? (
                  <CardVideoThumb
                    src={`${item.video}#t=0.1`}
                    muted
                    playsInline
                    preload="metadata"
                  />
                ) : (
                  <CardImage src={withPrefix(item.image)} />
                )}
                {item.video && (
                  <PlayOverlay aria-hidden="true">
                    <PlayButton />
                  </PlayOverlay>
                )}
              </CardMedia>
              <CardContent>
                <CardTitle>{item.title}</CardTitle>
              </CardContent>
            </Card>
          ))}
        </GalleryGrid>

        {selectedItem && (
          <ModalOverlay
            role="dialog"
            aria-modal="true"
            aria-label="Image preview"
            onClick={() => setSelectedItem(null)}
          >
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <ModalCloseButton onClick={() => setSelectedItem(null)} aria-label="Close">
                ×
              </ModalCloseButton>
              {selectedItem.video ? (
                <ModalVideo key={selectedItem.id} controls autoPlay playsInline>
                  <source src={selectedItem.video} type="video/mp4" />
                </ModalVideo>
              ) : (
                <ModalImage
                  src={withPrefix(selectedItem.image)}
                  alt={selectedItem.title || selectedItem.id}
                />
              )}
              <ModalCaption>
                {selectedItem.title}
              </ModalCaption>
            </ModalContent>
          </ModalOverlay>
        )}
        
      </PageContainer>
    </Layout>
  )
}
